// OFFICIAL API
export const BASE_URL_OGLASI = 'https://efee.etf.unibl.org:8443/api/public/oglasne-ploce/';
export const BASE_URL_PRILOG_DOWNLOAD = 'https://efee.etf.unibl.org:8443/api/public/oglasi/';
export const BASE_URL_ZAVRSNI_RADOVI = 'https://efee.etf.unibl.org:8443/api/public/zavrsni-radovi';

// TEST API
//export const BASE_URL_OGLASI = 'http://78.28.135.105:8080/api/public/oglasne-ploce/';
//export const BASE_URL_PRILOG_DOWNLOAD = 'http://78.28.135.105:8080/api/public/oglasi/';
//export const BASE_URL_ZAVRSNI_RADOVI = 'http://78.28.135.105:8080/api/public/zavrsni-radovi';

export const OGLASNE_PLOCE = [
  { id: 1, naziv: 'Prva godina' },
  { id: 2, naziv: 'Druga godina' },
  { id: 3, naziv: 'Treća godina' },
  { id: 4, naziv: 'Četvrta godina' },
  { id: 20, naziv: 'Drugi ciklus' },
  { id: 21, naziv: 'Odbrane završnih radova'},
  { id: 30, naziv: 'Treći ciklus' },
  { id: 102, naziv: 'Postdiplomski studij' }
];

export const MJESECI = [
  'januar',
  'februar',
  'mart',
  'april',
  'maj',
  'jun',
  'jul',
  'avgust',
  'septembar',
  'oktobar',
  'novembar',
  'decembar'
];

export const BREADCRUMB_LINKS = {
  'početna': '/',
  'oglasi': '/oglasi',
  'raspored': '/raspored',
  'završni radovi': '/zavrsni-radovi',
  'prva godina': '/oglasi/godina/1',
  'druga godina': '/oglasi/godina/2',
  'treća godina': '/oglasi/godina/3',
  'četvrta godina': '/oglasi/godina/4',
  'drugi ciklus': '/oglasi/godina/20',
  'odbrane završnih radova': '/oglasi/godina/21',
  'treći ciklus': '/oglasi/godina/30',
  'postdiplomski studij': '/oglasi/godina/102',
};

export const ZAVRSNI_RADOVI_FETCH_SIZE = 10;

export const STATUS_ZAVRSNI_RAD = {
  //"1": "Predložen",
  "2": "Odobren",
  "3": "Dodjeljen",
  "4": "Odbranjen",
  //"21": "Predložen",
  "22": "Odobren",
  "23": "Dodjeljen",
  "24": "Odbranjen"
};

export const STATUS_ZAVRSNI_RAD_CUSTOM = {
  "2": "Slobodan",
  "3": "Zauzet",
  "4": "Odbranjen",
  "22": "Slobodan",
  "23": "Zauzet",
  "24": "Odbranjen"
};

export const FILTER_SEARCH_FIELDS_ZAVRSNI_RAD = [
  'obrazlozenje',
  'trenutniStatus.statusZavrsnogRada.naziv',
  'mentor.ime',
  'predsjednikKomisije.ime',
  'clanKomisije.ime',
  'studentIme'
];